import { cn } from "@client/lib/cn";

const SIZES = {
  sm: { className: "size-7 text-xs", pixels: 28 },
  md: { className: "size-12 text-sm", pixels: 48 },
  lg: { className: "size-24 text-2xl md:size-28", pixels: 112 },
} as const;

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const initials = parts.length > 1 ? `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}` : name.slice(0, 2);
  return initials.toUpperCase();
}

interface AuthorAvatarProps {
  name: string;
  avatarUrl: string | null;
  size?: keyof typeof SIZES;
  className?: string;
}

/** Photo when the author has one, otherwise initials. Decorative: the name always sits beside it. */
export function AuthorAvatar({ name, avatarUrl, size = "md", className }: AuthorAvatarProps) {
  const { className: sizeClass, pixels } = SIZES[size];
  const base = cn("shrink-0 rounded-full border border-border-hover shadow-inner-highlight", sizeClass, className);
  if (avatarUrl) {
    return <img src={avatarUrl} alt="" width={pixels} height={pixels} loading="lazy" className={cn(base, "object-cover")} />;
  }
  return (
    <span aria-hidden="true" className={cn(base, "flex items-center justify-center bg-accent-soft font-semibold text-foreground")}>
      {initialsOf(name)}
    </span>
  );
}
